<template>
	<div class="relation-create__form">
		<div class="relation-create__row">
			<p>Направление:</p>
			<v-select v-model="relation.direction" :disabled="isEditableRelation"
				:class="relation.direction === null ? 'red-border' : ''" :options="directions"></v-select>
		</div>
		<div class="relation-create__row">
			<p>Контактное лицо:</p>
			<v-select v-if="clientsContact.length > 0" :disabled="isEditableRelation" v-model="relation.contact"
				:class="relation.contact === null ? 'red-border' : ''" label="name" :options="clientsContact"></v-select>
		</div>
		<div class="relation-create__row">
			<p>Тип встречи:</p>
			<v-select v-model="relation.mittingType" :disabled="isEditableRelation"
				:class="relation.mittingType === null ? 'red-border' : ''" :options="mittingTypes"></v-select>
		</div>
		<div class="relation-create__row">
			<p>Цель встречи:</p>
			<el-input :class="relation.theme.length < 5 ? 'red-border' : ''" :disabled="isEditableRelation" size="small"
				v-model="relation.theme" />
		</div>
		<div class="relation-create__row">
			<p>Результат встречи:</p>
			<el-input :class="relation.result.length < 5 ? 'red-border' : ''" :disabled="isEditableRelation" type="textarea"
				size="small" rows="4" resize="none" placeholder="Введите результат встречи" v-model="relation.result" />
		</div>
		<div class="relation-create__row">
			<p>Успешность встречи:</p>
			<el-radio-group v-model="relation.success" :disabled="isEditableRelation">
				<el-radio :label="true">Да</el-radio>
				<el-radio :label="false">Нет</el-radio>
			</el-radio-group>
		</div>
		<div class="relation-create__row relation-create__footer" style="padding-bottom: 150px;">
			<el-button v-if="!isEditableRelation" size="small" type="warning" @click="emptyForm">Очистить форму</el-button>
			<el-button :disabled="!validateFormNewRelation" :loading="isSentingRelation" size="small" type="success"
				@click="createRelation">
				Сохранить</el-button>
		</div>
	</div>
</template>

<script>
import { ADRESS } from "@/store/actions/auth"
import axios from "axios"
import { mapGetters } from "vuex"

export default {
	name: "vRelationTG",
	data() {
		return {
			relation: {
				theme: "",
				result: "",
				contact: null,
				success: null,
				direction: null,
				mittingType: null,
			},
			directions: [
				"Вилочная техника",
				"Складская техника",
				"Дорожно-строительная техника",
				"Шины",
				"Запасные части",
				"АКБ",
				"Сервис"
			],
			mittingTypes: ["Выездная встреча", "В офисе"],
			isSentingRelation: false,
		}
	},
	props: {
		clientsContact: Array,
		activities: String,
		uikCompany: String,
		isEditableRelation: Boolean,
		currentRelation: Object,
		company: Object,
	},
	created() { },
	mounted() {
		this.emptyForm()
		if (this.isEditableRelation === true) {
			this.getRelationData()
		}
	},
	computed: {
		validateFormNewRelation() {
			return (
				this.relation.theme.length > 4 &&
				this.relation.result.length > 4 &&
				this.relation.contact !== null &&
				this.relation.success !== null &&
				this.relation.direction !== null &&
				this.relation.mittingType !== null
			)
		},
		isCreatingRelation() {
			return this.$store.getters.isCreatingRelation
		},
		...mapGetters(["telegramId"]),
	},
	watch: {
		isCreatingRelation(value) {
			if (value === false) {
				this.emptyForm()
			} else if (value === true) {
				if (this.isEditableRelation === true) {
					this.getRelationData()
				}
			}
		},
	},
	methods: {
		emptyForm() {
			this.relation.theme = ""
			this.relation.result = ""
			this.relation.contact = null
			this.relation.success = null
			this.relation.direction = null
			this.relation.mittingType = null
		},
		createRelation() {
			this.isSentingRelation = true

			// Получаем текущее время в формате yyyyMMddHHmmss
			const currentDateTime = new Date()
			const formattedDateTime = this.formatDateTime(currentDateTime)

			// Создаем адаптированный объект для отправки
			const adaptedRelation = {
				...this.relation,
				mittingTimeStart: formattedDateTime,
				mittingTimeEnd: formattedDateTime,
				mittingTime: [formattedDateTime, formattedDateTime],
				mittingPlace: "",
				description: this.relation.result, // Результат встречи -> описание
				comments: [],
				reviewDate: null,
				isReviewed: false
			}

			if (this.isEditableRelation === false) {
				axios({
					method: "post",
					url: ADRESS + "createrelation",
					data: {
						...adaptedRelation,
						uik: this.uikCompany,
					},
					headers: {
						Authorization: this.activities,
					},
				})
					.then((response) => {
						this.isSentingRelation = false
						this.$notify.success({
							title: "Сохранено",
							message: response.status,
						})
						const uik = response.data.uik
						this.$emit("addNewRelation", { ...this.relation, uik: uik })

						// Отправляем данные в Telegram API для подтверждения встречи
						this.sendMeetingConfirmationToTelegram()

						this.emptyForm()
					})
					.catch((err) => {
						console.log(err)
						this.isSentingRelation = false
						this.$notify.error({
							title: "Ошибка",
							message: err,
						})
					})
			} else {
				axios({
					method: "post",
					url: ADRESS + "editrelation",
					data: {
						...adaptedRelation,
						uikrelation: this.currentRelation["УИК"],
						type: this.currentRelation["Тип"],
						uik: this.uikCompany,
					},
					headers: {
						Authorization: this.activities,
					},
				})
					.then((response) => {
						this.isSentingRelation = false
						this.$notify.success({
							title: "Сохранено",
							message: response.status,
						})
						const uik = response.data.uik
						this.$emit("addNewRelation", { ...this.relation, uik: uik })
						this.emptyForm()
					})
					.catch((err) => {
						console.log(err)
						this.isSentingRelation = false
						this.$notify.error({
							title: "Ошибка",
							message: err,
						})
					})
			}
		},
		getRelationData() {
			axios({
				method: "get",
				url: ADRESS + "viewrelation",
				params: {
					uikrelation: this.currentRelation["УИК"],
					type: this.currentRelation["Тип"],
					uik: this.uikCompany,
				},
				headers: {
					Authorization: this.activities,
				},
			})
				.then((response) => {
					// Адаптируем полученные данные для нашего компонента
					const responseData = response.data

					// Преобразуем данные в формат нашего компонента
					this.relation.theme = responseData.theme || ""
					this.relation.result = responseData.description || ""
					this.relation.contact = responseData.contact || null
					this.relation.success = responseData.hasOwnProperty("success") ? responseData.success : null
					this.relation.direction = responseData.direction || null
					this.relation.mittingType = responseData.mittingType || null

					console.log("Получены данные о встрече:", responseData)
				})
				.catch((err) => {
					console.log(err)
					this.$notify.error({
						title: "Ошибка",
						message: err,
					})
					this.$emit("closeDialog")
				})
		},
		// Форматирование даты в формат yyyyMMddHHmmss
		formatDateTime(date) {
			const year = date.getFullYear()
			const month = String(date.getMonth() + 1).padStart(2, '0')
			const day = String(date.getDate()).padStart(2, '0')
			const hours = String(date.getHours()).padStart(2, '0')
			const minutes = String(date.getMinutes()).padStart(2, '0')
			const seconds = String(date.getSeconds()).padStart(2, '0')

			return `${year}${month}${day}${hours}${minutes}${seconds}`
		},
		// Отправляем данные в Telegram API для подтверждения встречи
		sendMeetingConfirmationToTelegram() {
			// Проверяем наличие компании в props
			if (!this.company) {
				console.error("Не удалось получить данные о компании")
				return
			}

			// Получаем telegram_id из хранилища Vuex через геттер или из localStorage
			let telegramId = this.telegramId

			// Если не получили из Vuex, пробуем взять из localStorage
			if (!telegramId) {
				telegramId = localStorage.getItem("telegram-id")
				console.log("Пытаемся получить Telegram ID из localStorage:", telegramId)
			}

			// Если не получили из localStorage, проверяем наличие данных пользователя
			if (!telegramId) {
				const telegramUserData = localStorage.getItem("telegram-user-data")
				if (telegramUserData) {
					try {
						const userData = JSON.parse(telegramUserData)
						if (userData && userData.id) {
							telegramId = userData.id
							console.log("Получен Telegram ID из сохраненных данных пользователя:", telegramId)

							// Обновляем state и localStorage
							localStorage.setItem("telegram-id", telegramId)
							this.$store.commit('updateTelegramId', telegramId)
						}
					} catch (e) {
						console.error("Ошибка при парсинге данных пользователя Telegram:", e)
					}
				}
			}

			if (!telegramId) {
				console.error("Не найден Telegram ID пользователя")
				return
			}

			console.log("Используем Telegram ID для отправки:", telegramId)

			// Подготовка данных для отправки
			const meetingData = {
				company_uik: this.uikCompany,
				company_inn: this.company["ИНН"] || "",
				company_name: this.company["НаименованиеПолное"] || "",
				purpose: this.relation.theme,
				status: this.relation.success ? "success" : "failure",
				meeting_type: this.relation.mittingType,
				meeting_direction: this.relation.direction,
				meeting_result: this.relation.result,
				telegram_id: telegramId,
				contact_name: this.relation.contact.name,
				contact_phone: this.relation.contact.phone,
				contact_position: this.relation.contact.position,
			}

			// Отправляем данные на API сервер
			axios({
				method: "post",
				url: "https://m.liftnet.ru/api/v1/telegram/initiate-meeting-confirmation",
				data: meetingData
			})
				.then(response => {
					console.log("Данные о встрече успешно отправлены в Telegram:", response.data)
					this.closeTelegramMiniApp()
				})
				.catch(error => {
					console.error("Ошибка при отправке данных о встрече в Telegram:", error)
				})
		},
		// Метод для закрытия Telegram mini app
		closeTelegramMiniApp() {
			// Проверяем доступность Telegram WebApp API
			if (window.Telegram && window.Telegram.WebApp) {
				console.log("Закрываем Telegram mini app")
				window.Telegram.WebApp.close()
			} else {
				console.warn("Telegram WebApp API не доступен")
			}
		},
	},
}
</script>

<style lang="scss">
.relation-create__form {
	.relation-create__row {
		margin-bottom: 15px;

		p {
			margin-bottom: 5px;
			font-weight: bold;
		}
	}

	.red-border {
		border-color: #f56c6c;
	}

	.relation-create__footer {
		margin-top: 20px;
		display: flex;
		justify-content: flex-end;
		gap: 10px;
	}
}
</style>